<template>
<b-row>
  <b-col md="3" sm="12">
    <b-form-group>
      <label>{{$t('views.excmrelation.show.dateFrom')}}:</label>
      <VueCtkDateTimePicker no-header
                            :label="$t('views.excmrelation.show.dateFrom')"
                            v-model.lazy="filters['messageDateTime[after]']"
                            v-debounce="delay"
                            format="YYYY-MM-DD"
                            :onlyDate="true"
                            :right="true"
                            formatted="ll"
      >
      </VueCtkDateTimePicker>
    </b-form-group>
  </b-col>
  <b-col md="3" sm="12">
    <b-form-group>
      <label>{{$t('views.excmrelation.show.dateTo')}}:</label>
      <VueCtkDateTimePicker no-header
                            :label="$t('views.excmrelation.show.dateTo')"
                            v-model.lazy="filters['messageDateTime[before]']"
                            v-debounce="delay"
                            format="YYYY-MM-DD"
                            :onlyDate="true"
                            :right="true"
                            formatted="ll"
      >
      </VueCtkDateTimePicker>
    </b-form-group>
  </b-col>
  <b-col sm="6" md="3">
    <label class="form-control-label">{{ $t('views.excmcorrespondence.list.subject') }}:</label>
    <input v-model.lazy="filters.subject" v-debounce="delay" class="form-control" type="text" :placeholder="$t('views.excmcorrespondence.list.subject')"/>
  </b-col>
  <b-col sm="6" md="3">
    <label class="form-control-label">{{ $t('views.excmnotificationmessage.form.mailBody') }}:</label>
    <input v-model.lazy="filters['messages.message']" v-debounce="delay" class="form-control" type="text" :placeholder="$t('views.excmnotificationmessage.form.mailBody')"/>
  </b-col>
  <b-col sm="6" md="3" v-if="!idContractor">
    <div class="form-group">
      <label class="form-control-label">{{ $t('views.financialreport.list.contractor') }}:</label><br>
      <base-select-input
        v-model="filters.idContractor"
        :search-callback="userDataSearchCallback"
        :display-values="['fullName', 'firmname1']"
        :query-param="'userdata'"
        :is-auto-complete-mode="$store.getters['configuration/enableAutoCompleteForUserData']"
      ></base-select-input>
    </div>
  </b-col>
  <b-col sm="6" md="3">
    <label class="form-control-label">{{ $t('views.excmcorrespondence.list.emails') }}:</label>
    <input v-model.lazy="filters.correspondenceEmails" v-debounce="delay" class="form-control" type="text" :placeholder="$t('views.excmcorrespondence.list.emails')"/>
  </b-col>
</b-row>
</template>

<script>
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker'
import debounce from 'v-debounce'
import addParamsToQuery from '@/utils/addParamsToQuery'
import BaseSelectInput from '@/components/BaseComponents/BaseSelectInput'
import ApiService from '@/utils/ApiService'
export default {
  name: 'CorrespondenceThreadsFiltering',
  components: {
    BaseSelectInput,
    VueCtkDateTimePicker
  },
  directives: {
    debounce
  },
  props: {
    idContractor: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      filtersReference: {},
      delay: 500,
      filters: {
        'messageDateTime[after]': '',
        'messageDateTime[before]': '',
        subject: '',
        idContractor: this.idContractor,
        'messages.message': '',
        correspondenceEmails: ''
      }
    }
  },
  created () {
    this.filtersReference = JSON.parse(JSON.stringify(this.filters))
  },
  watch: {
    filters: {
      deep: true,
      handler () {
        let url = 'e_x_c_m_correspondence_threads'
        this.getPage(addParamsToQuery(url, this.filters))
      }
    }
  },
  methods: {
    getPage (url) {
      this.$emit('getPage', url)
    },
    clearFilters () {
      this.filters = JSON.parse(JSON.stringify(this.filtersReference))
    },
    async userDataSearchCallback (params = {}) {
      let baseParams = { pagination: false }
      Object.assign(baseParams, params)
      const response = await new ApiService('user_datas/list', baseParams).getResults()
      return response.items
    }
  }
}

</script>

<style scoped>

</style>
